import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react'
import { createPortal } from 'react-dom'
import { t } from 'ttag'
import { Modal } from 'react-bootstrap'


import debounce from 'lodash/debounce'

import add from '@h2/assets/svg/icons/add.svg'
import filterSvg from '@h2/assets/svg/icons/filter.svg'

import OccupationSuggestField from './filters/renderers/OccupationSuggestField'
import MajorSuggestField from './filters/renderers/MajorSuggestField'
import InstitutionSuggestField from './filters/renderers/InstitutionSuggestField'

import { guessSearchResultType, updateQueryParams } from '../../actions/search'
import Field from '../form/Field'
import Form from '../form/Form'
import { scrollToTopOfScreen } from '../../actions'



const defaultScrollProps = {
  scrollTop: 0,
  totalHeight: 0,
  windowHeight: 0,
  selectorOpen: false,
  transitionTop: 200
}
const FilterBar = props => {
  const [additionalFiltersOpen, setAdditionalFiltersOpen] = useState(false)
  const [initialFilterForm, setInitialFilterForm] = useState(props.searchFilterForm)
  const [scrollProps, setScrollProps] = useState(defaultScrollProps)
  const searchBarRef = useRef(null)
  const hasData = a => {
    return !!a && Object.keys(a).length > 0
  }
  const debouncedHandleScroll = useMemo(
    () =>
      debounce(
        () => {
          setScrollProps({
            ...scrollProps,
            scrollTop: window.scrollY
          })
        },
        250,
        { leading: true, maxWait: 750 }
      ),
    [setScrollProps, scrollProps]
  )
  const handleScroll = useCallback(() => {
    debouncedHandleScroll()
  }, [debouncedHandleScroll])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  useEffect(() => {
    if (hasData(props.searchFilterForm)) {
      setInitialFilterForm(props.searchFilterForm)
    }
  }, [props.searchFilterForm])

  useEffect(() => {
    const totalHeight = document.body.clientHeight
    const windowHeight = window.innerHeight
    const offsetTop = el => {
      const rect = el.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      return (rect.top + scrollTop) * 0.9
    }

    setScrollProps({
      ...defaultScrollProps,
      totalHeight,
      windowHeight,
      transitionTop: offsetTop(searchBarRef.current)
    })
  }, [props.filtersFromResponse, searchBarRef])

  const filterMultiOptions = (filter, filterOption, inSelectionModal) => {
    const filterOptions = initialFilterForm[filter.id]
    let isSelected = false

    if (filterOptions) {
      isSelected = Array.isArray(filterOptions)
        ? filterOptions.includes(filterOption.id)
        : !!filterOptions[filterOption.id]
    }

    return inSelectionModal ? true : isSelected
  }
  const outputFilter = (
    filter,
    form,
    className = 'col-sm-3',
    inSelectionModal = false
  ) => {
    //


    const wrap = (additionalProps, childData, label = filter.name) => {
      const fieldModelName = `${props.searchFilterFormName}.${filter.id}`


      return (
        <div className={className}>
          <Field
            model={fieldModelName}
            form={form}
            type={filter.type}
            label={label}
            {...additionalProps}>
            {childData}
          </Field>
        </div>
      )
    }
    const generateRangeForFilter = () => {
      //I am ignoring money type here since it doesn't format well (leaving the formatter though so we can revert)
      const ticks =
        filter.ticks && filter.ticks.length > 0 && filter.formatType !== 'money'
          ? {
              ticks: filter.ticks,
              ticks_labels: (filter.ticks || []).map(tick =>
                filter.formatType === 'money'
                  ? `${tick.toLocaleString('en-US', {
                      style: 'currency',
                      maximumFractionDigits: 0,
                      minimumFractionDigits: 0,
                      currency: 'USD'
                    })}`
                  : `${tick}`
              )
            }
          : {}
      const additionalProps = {
        min: filter.minAllowedValue,
        step: filter.step || 1,
        range: true,
        max: filter.maxAllowedValue,
        immediateChange: true,
        ...ticks
      }
      const values = props.searchFilterFormModel[filter.id]
      const valMin = values && values.length > 1 ? values[0] : 0
      const valMax = values && values.length > 1 ? values[1] : 10
      let descMin = `${valMin}`
      let descMax = `${valMax}`

      if (filter.options) {
        //If there are options, we'll attempt to guess at what the selected value actually represents
        const dM = filter.options.find(opt => opt.id == valMin)?.label
        const dMx = filter.options.find(opt => opt.id == valMax)?.label

        /*
         * There are some options that have a range, and it doesn't work well to show a range to a range,
         * so we try to break it up. It may end up that we need a tighter criteria since - may show up in
         * text, but for now this works.
         */
        if (dM) {
          if (dM.includes('-')) {
            descMin = dM.slice(0, dM.indexOf('-')).trim()
          } else {
            descMin = dM
          }
        }

        if (dMx) {
          if (dMx.includes('-')) {
            descMax = dMx.slice(dMx.indexOf('-') + 1).trim()
          } else {
            descMax = dMx
          }
        }
      } else if (filter.formatType === 'money') {
        descMin = valMin?.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
        descMax = valMax?.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
      }

      const label = `${filter.name}: ${descMin} - ${descMax}`

      return wrap(additionalProps, null, label)
    }
    const defaultPropsForExternalFilter = {
      filter,
      form,
      searchFilterFormName: props.searchFilterFormName
    }
    const wrapToggleOrCheckIn = (ele, parentLabel = null) => {


      return (
        <div className={className}>
          {parentLabel ? (
            <label style={{ fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
              {parentLabel}
            </label>
          ) : null}
          {ele}
        </div>
      )
    }
    const outputToggleOrCheckField = (f, labelTop = false) => {
      const setOptions = props.searchFilterForm[filter.id] || {}

      const label =
        filter.type === 'toggle' ? (
          <div style={{ clear: 'left' }}>{f.label}</div>
        ) : (
          f.label
        )

      return (
        <Field
          labelTop={labelTop}
          key={`${filter.id}-${f.id}`}
          model={`${props.searchFilterFormName}.${filter.id}[${f.id}]`}
          form={form}
          type={filter.type}
          className={`${filter.type === 'toggle' ? 'toggle-switch' : ''} ${f.cssClass}`}
          checked={setOptions[f.id]}
          label={label}>
        </Field>
      )
    }

    //

    switch (filter.type) {
      case 'range':
        return generateRangeForFilter()

      case 'select':
        return wrap(
          null,
          filter.options?.map(opt => (
            <option value={opt.id} key={`filter-option-${opt.id}`}>
              {opt.label}
            </option>
          ))
        )

      case 'multiselect.onetsoc':
        return (
          <div className={inSelectionModal ? 'col-sm-12' : 'col-sm-6'}>
            <OccupationSuggestField {...defaultPropsForExternalFilter} />
          </div>
        )

      case 'multiselect.cipcode':
        return (
          <div className={inSelectionModal ? 'col-sm-12' : 'col-sm-6'}>
            <MajorSuggestField {...defaultPropsForExternalFilter} />
          </div>
        )

      case 'multiselect.ipeds':
        return (
          <div className={inSelectionModal ? 'col-sm-12' : 'col-sm-6'}>
            <InstitutionSuggestField {...defaultPropsForExternalFilter} />
          </div>
        )

      case 'toggle':
      case 'checkbox':
        if (!filter.options) {
          const label =
            filter.type === 'toggle' ? (
              <div style={{ clear: 'left' }}>{filter.name}</div>
            ) : (
              filter.name
            )

          return wrap(
            {
              labelTop: filter.type === 'toggle',
              checked: props.searchFilterForm[filter.id] || filter.value,
              className: `${filter.type === 'toggle' ? 'toggle-switch' : ''} ${
                filter.cssClass || filter.id
              }`
            },
            null,
            label
          )
        }

        return filter.itemPerContainer
          ? filter.options
              .filter(filterOption =>
                filterMultiOptions(filter, filterOption, inSelectionModal)
              )
              .map(f =>
                wrapToggleOrCheckIn(outputToggleOrCheckField(f, filter.type === 'toggle'))
              )
          : wrapToggleOrCheckIn(
              filter.options.map((f, pos, lst) => (
                <div
                  className={`col-xs-${Math.ceil(12 / lst.length)}`}
                  key={`element-in-results-${pos}`}>
                  {outputToggleOrCheckField(f)}
                </div>
              )),
              filter.name
            )

      case 'zipcode.select':
        return (
          <div className={className}>
            <div className="row">
              <div className={'col-xs-7'} style={{ paddingRight: '1px' }}>
                <Field
                  label={filter.name}
                  key={`${filter.id}-zipcode`}
                  model={`${props.searchFilterFormName}.${filter.id}.zipCode`}
                  form={form}
                  type="text">
                </Field>
              </div>
              <div className={'col-xs-5'} style={{ paddingLeft: '1px' }}>
                <Field
                  key={`${filter.id}-radius`}
                  label={t`Radius`}
                  model={`${props.searchFilterFormName}.${filter.id}.radius`}
                  form={form}
                  type="select">
                  {filter.options.radius.map(radius => (
                    <option key={`zip-search-${radius}`} value={`${radius}`}>
                      {radius} {t`mi`}
                    </option>
                  ))}
                </Field>
              </div>
            </div>
          </div>
        )
      default:
        return wrap(null, null)
    }
  }
  const generateTypesSelection = (types, form) => {


    if (!types || types.length === 0) {
      return null
    }

    //

    return (
      <div className="col-sm-3">
        <Field
          model={`${props.searchFilterFormName}.types`}
          form={form}
          type="select"
          label={t`Result Type`}>
          <option value="">{t`All Results`}</option>
          {types.map(typ => {
            const typeInfo = guessSearchResultType(typ.type)

            return (
              <option value={typ.type} key={typ.type}>
                {typeInfo.title || typ.type} ({typ.resultCount})
              </option>
            )
          })}
        </Field>
      </div>
    )
  }
  const toggleAdditionalFilters = () => {
    setAdditionalFiltersOpen(!additionalFiltersOpen)
  }
  /*
   *

   *

   */
  const types = props.searchResponse?.alternateTypes ?? []
  const isScrolled = scrollProps.scrollTop > scrollProps.transitionTop
  //
;
  const filters = props.searchResponse?.filters ?? []
  /*
   * const primaryFilters = filters.filter(f => f.displayPriority == 'primary')
   * const secondaryFilters = filters.filter(f => f.displayPriority != 'primary')
   */
  const appliedFilters = filters.filter(filt => filt.isApplied)
  /*
   *

   *

   */
  /*
   *If we want an animated position bar
   */
  const filterSortFn = (initial, comparison) => {
    if (initial.filterPriorityOrder && comparison.filterPriorityOrder) {


      return initial.filterPriorityOrder - comparison.filterPriorityOrder
    }

    if (initial.filterPriorityOrder) {
      return -1
    }

    if (comparison.filterPriorityOrder) {
      return 1
    }

    return 0
  }
  const menuBarFilterContent = form => {
    const typeSelection = generateTypesSelection(types, form)
    const numToShow = 2
    const splitList = list => {
      let filtersToShow = list
      let numHidden = 0

      if (list.length > numToShow) {
        filtersToShow = list.slice(0, numToShow)
        numHidden = list.length - numToShow
      }

      return { filtersToShow, numHidden }
    }
    const sortedFilters = appliedFilters.sort(filterSortFn)
    let { filtersToShow, numHidden } = splitList(sortedFilters)
    let wrapFiltersSeparateFromAdd = false
    let filtersToDisplay = null

    if (appliedFilters.length > 0) {
      filtersToDisplay = filtersToShow.map((f, p, lst) => {
        if (f.type === 'toggle' && !f.itemPerContainer) {
          if (lst.length === 3 && !wrapFiltersSeparateFromAdd) {
            wrapFiltersSeparateFromAdd = true
          }

          return outputFilter(f, form, 'col-sm-6')
        }

        return outputFilter(f, form)
      })
    }

    const updatedFilters = filtersToDisplay?.flatMap(f => (Array.isArray(f) ? f : [f]))

    if (updatedFilters && updatedFilters.length >= numToShow) {
      numHidden = numHidden + (updatedFilters.length - numToShow)
      filtersToDisplay = updatedFilters.slice(0, numToShow)
    }

    const filterThisListButton = () => {
      if (numHidden === 0) {
        if (appliedFilters.length === 0) {
          return <div className="always-visible">{t`Add Filter`}</div>
        }

        return <div>{t`Filters`}</div>
      }

      return null
    }
    const addFilterButton =
      !props.isLoading && filters.length > 0 ? (
        <div className={appliedFilters.length === 0 ? 'col-sm-8' : 'col-sm-2'}>
          {numHidden > 0 ? (
            <a
              role="link"
              onClick={toggleAdditionalFilters}
              onKeyDown={toggleAdditionalFilters}
              tabIndex={0}
              style={{
                color: 'white',
                lineHeight: '58px',
                float: 'left',
                fontSize: '.9rem',
                marginRight: '10px'
              }}>
              {t`plus ${numHidden} more`}
            </a>
          ) : null}
          <button
            onClick={toggleAdditionalFilters}
            type="button"
            style={{ marginTop: '11px', padding: 0, marginRight: '8px' }}
            className={`expandable-button small`}>
            <span className={numHidden === 0 ? 'icon' : ''}>
              <img
                src={add}
                alt={t`Add additional filters`}
                className="pull-right"
                aria-hidden="true"
                style={{
                  maxWidth: '36px',
                  maxHeight: '36px'
                }}
              />{' '}
            </span>
            {filterThisListButton()}
          </button>
        </div>
      ) : null
    /**
     * conditionally wrap the filters and add more button if we have three, otherwise the line breaks funny
     * @returns {JSX.Element|(*)[]}
     */
    const outputTypes = () => {
      const outputItems = [typeSelection, filtersToDisplay]

      if (wrapFiltersSeparateFromAdd) {
        return (
          <div className="col-xs-10">
            <div className="row">{outputItems}</div>
          </div>
        )
      }

      return outputItems
    }

    return (
      <div className="row">
        {outputTypes()}
        {addFilterButton}
      </div>
    )
  }
  //

  const filterJsx = (
    <div
      className={`search-filter-bar ${isScrolled ? 'search-filters-fixed' : 'row'}`}
      key={`search-results-container`}
      ref={searchBarRef}>
      <div
        style={{
          height: '3px',
          width: '101%',
          margin: '-3px',
          marginBottom: '3px',
          position: 'relative',
          backgroundColor: '#bbb7d4',
          display: isScrolled ? 'block' : 'none'
        }}>
        <div
          style={{
            width: `${100 * (scrollProps.scrollTop / props.maxWindowHeight)}%`,
            height: '3px',
            backgroundColor: 'orange',
            position: 'absolute',
            left: 0,
            top: 0
          }}>
        </div>
      </div>
      <div
        className={
          isScrolled
            ? 'container'
            : `search-filters ${props.hasRecommendations ? 'with-recs' : 'without-recs'}`
        }>
        <Form
          model={props.searchFilterFormName}
          onSubmit={form => {
            setInitialFilterForm(form)
            updateQueryParams(form, props.filtersFromResponse)
          }}>
          {form => (
            <div key="search-filter-form-div" className={isScrolled ? 'row' : ''}>
              <div className="col-sm-10">{menuBarFilterContent(form)}</div>
              <div className="col-sm-2">
                {!props.isLoading &&
                (appliedFilters.length > 0 || !!generateTypesSelection(types, form)) ? (
                  <button
                    type="submit"
                    className="btn btn-default no-style pull-right"
                    style={{
                      marginTop: '12px'
                    }}>
                    <img
                      src={filterSvg}
                      alt={t`Filter icon`}
                      className="pull-left"
                      aria-hidden="true"
                      style={{
                        width: '20px',
                        maxHeight: '20px'
                      }}
                    />{' '}
                    {t`Update`}
                  </button>
                ) : null}
              </div>
            </div>
          )}
        </Form>

        <Modal
          show={additionalFiltersOpen}
          bsSize="lg"
          static={true}
          aria-labelledby="modal-title"
          onHide={toggleAdditionalFilters}>
          <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
            <button
              type="button"
              className="close"
              aria-label={t`Close`}
              onClick={toggleAdditionalFilters}>
              <span aria-hidden="true">×</span>
            </button>
            <h2 id="modal-title">{t`Additional Filters`}</h2>
          </Modal.Header>
          <Modal.Body>
            <Form
              model={props.searchFilterFormName}
              onSubmit={form => {
                setInitialFilterForm(form)
                toggleAdditionalFilters()
                updateQueryParams(form, props.filtersFromResponse)
              }}>
              {form => [
                <div className="row" key="filterrow">
                  {filters
                    .sort(filterSortFn)
                    .map(f =>
                      outputFilter(
                        f,
                        form,
                        f.spanWholeRow ? 'col-xs-12' : 'col-xs-6',
                        true
                      )
                    )}
                </div>,
                <div
                  key="submission"
                  className="modal-footer"
                  style={{ margin: '15px -15px -15px -15px' }}>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    aria-label={t`Close Window`}>
                    {t`Close and Update`}
                  </button>
                </div>
              ]}
            </Form>
          </Modal.Body>
        </Modal>

        <p
          style={{ display: isScrolled ? 'block' : 'none' }}
          className="scrolled-summary-text">
          <button
            style={{
              background: 'none',
              border: 'none',
              padding: '0'
            }}
            className="top-btn-style pull-right hover-bounce"
            onClick={scrollToTopOfScreen}>
            <i className="share" style={{ transform: 'rotate(-90deg) scaleY(-1)' }}></i>
          </button>
          {props.scrolledSummaryText}
        </p>
        <br className="clear" />
      </div>
    </div>
  )

  return isScrolled
    ? [
        <div style={{ height: '85px' }} key="element-spacer-bar"></div>,
        createPortal(filterJsx, document.getElementsByTagName('body')[0])
      ]
    : filterJsx
}

export default FilterBar
